import React, { useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import './pin-update-form.scss'
import { updatePin} from '../../../services/users';
import { toast } from 'react-toastify';
import BeatLoader from "react-spinners/BeatLoader";
import Constant from "../../../Constant";

const orderSchema = Yup.object().shape({
  pin: Yup.string()
    .required('PIN is required')
    .min(5, 'PIN must be exactly 5 characters')
    .max(5, "PIN must be exactly 5 characters")
    .matches(
      /^([a-zA-Z0-9]){0,5}/,
      'PIN should be alphanumeric. No special characters allowed'
    ).trim(),
  oldPin: Yup.string()
    .required('Ce champs est obligatoire')
    .trim(),  
  confirmPin: Yup.string()
    .required('Ce champs est obligatoire')
    .trim(),
});

const PinUpdateForm = ({ userId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = (values) => {
    setIsLoading(true);
    console.log(`Submitting the following data ${JSON.stringify(values)}`);
    updatePin(values).then(res => {
      if(res.status_code == 200 || res.status_code == 201) {
        toast(`${res.message}. You can close this page and return to the app`);
        setMessage(`${res.message}. You can close this page and return to the app`);
      }else {
        toast(`Sorry! ${res.message}`);
        setErrorMessage(res.message);
      }
    }).catch(err => {
      toast(`Sorry, ${err.message}`)
      setErrorMessage(err.message);
    }).finally( () => {
      setIsLoading(false);
      setFormSubmitted(true);
    })
  };

  return  (
    <div className="login-form">
      <div className="login-error">{ errorMessage ? errorMessage : ''}</div>
      <div className='login-info'><h2>AFTA WALLET</h2></div>
      { !formSubmitted &&
        <Formik
        initialValues={{
          pin: "",
          confirmPin: "",
          oldPin: "",
          id: userId,
        }}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
        validationSchema={orderSchema}
        >
        {({ handleSubmit, values, handleChange, errors, touched }) => (
          <form onSubmit={handleSubmit}>
            
            <div className={`field`}>
              <p>Veuillez confirmer le changement de votre code PIN.</p>
            </div>
            <div className={`field`}>
              <label htmlFor="oldPin">PIN code</label>
              <input
                name="oldPin"
                id="oldPin"
                type='password'
                placeholder="Votre ancien code PIN"
                value={values.oldPin}
                onChange={handleChange}
              />
              {errors.oldPin && touched.oldPin ? (
                <div className="error">{errors.oldPin}</div>
              ) : null}
            </div>
            <div className={`field`}>
              <label htmlFor="pin">Nouveau PIN code</label>
              <input
                name="pin"
                id="pin"
                type='password'
                placeholder="Votre code PIN"
                value={values.pin}
                onChange={handleChange}
              />
              {errors.pin && touched.pin ? (
                <div className="error">{errors.pin}</div>
              ) : null}
            </div>
            <div className={`field`}>
              <label htmlFor="confirmPin">Confirmer le PIN</label>
              <input
                name="confirmPin"
                id="confirmPin"
                type='password'
                placeholder="Confirmer le code PIN"
                value={values.confirmPin}
                onChange={handleChange}
              />
              {errors.confirmPin && touched.confirmPin ? (
                <div className="error">{errors.confirmPin}</div>
              ) : null}
            </div>
            <button type="submit" disabled={isLoading}>
              {!isLoading && <span>CONFIRMER</span>}
              {/* {isLoading && <span>Sending ...</span>} */}
              <BeatLoader
                color={Constant.spinner_color}
                loading={isLoading}
                cssOverride={{
                  textAlign: 'center',
                  marginTop: '20px'
                }}
              />
              {/* {isLoading && <Loader />} */}
            </button>
          </form>
        )}
        </Formik>
      }
      {
        formSubmitted && 
        <p className='login-info'>
          {message}
        </p>
      }
    </div>
  );
};

export default PinUpdateForm;
